export default function addLeadingZeros (text: string, length: number = 2) {
  while (text.length < length) {
    text = `0${text}`
  }
  return text
}
